import v from "../../../../_virtual/isString.js";
import x from "../../../../_virtual/isNaN.js";
import h from "../../../../_virtual/get.js";
import O from "../../../../_virtual/isNumber.js";
var P = function(r) {
  return r === 0 ? 0 : r > 0 ? 1 : -1;
}, d = function(r) {
  return v(r) && r.indexOf("%") === r.length - 1;
}, m = function(r) {
  return O(r) && !x(r);
}, b = function(r) {
  return m(r) || v(r);
}, N = 0, A = function(r) {
  var n = ++N;
  return "".concat(r || "").concat(n);
}, E = function(r, n) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!m(r) && !v(r))
    return t;
  var i;
  if (d(r)) {
    var f = r.indexOf("%");
    i = n * parseFloat(r.slice(0, f)) / 100;
  } else
    i = +r;
  return x(i) && (i = t), u && i > n && (i = n), i;
}, k = function(r) {
  if (!r)
    return null;
  var n = Object.keys(r);
  return n && n.length ? r[n[0]] : null;
}, q = function(r) {
  if (!Array.isArray(r))
    return !1;
  for (var n = r.length, t = {}, u = 0; u < n; u++)
    if (!t[r[u]])
      t[r[u]] = !0;
    else
      return !0;
  return !1;
}, D = function(r, n) {
  return m(r) && m(n) ? function(t) {
    return r + t * (n - r);
  } : function() {
    return n;
  };
};
function L(e, r, n) {
  return !e || !e.length ? null : e.find(function(t) {
    return t && (typeof r == "function" ? r(t) : h(t, r)) === n;
  });
}
var M = function(r) {
  if (!r || !r.length)
    return null;
  for (var n = r.length, t = 0, u = 0, i = 0, f = 0, o = 1 / 0, c = -1 / 0, a = 0, l = 0, s = 0; s < n; s++)
    a = r[s].cx || 0, l = r[s].cy || 0, t += a, u += l, i += a * l, f += a * a, o = Math.min(o, a), c = Math.max(c, a);
  var g = n * f !== t * t ? (n * i - t * u) / (n * f - t * t) : 0;
  return {
    xmin: o,
    xmax: c,
    a: g,
    b: (u - g * t) / n
  };
};
export {
  L as findEntryInArray,
  k as getAnyElementOfObject,
  M as getLinearRegression,
  E as getPercentValue,
  q as hasDuplicate,
  D as interpolateNumber,
  b as isNumOrStr,
  m as isNumber,
  d as isPercent,
  P as mathSign,
  A as uniqueId
};
